<template>
	<div class="enterprises">
		<h1>与更多的优秀企业一起加入</h1>
		<div class="first-group">
			<HoverPicture :dataList="firstGroup"></HoverPicture>
		</div>
		<div class="second-group">
			<HoverPicture :dataList="secondGroup"></HoverPicture>
		</div>
		<div class="third-group">
			<HoverPicture :dataList="thirdGroup"></HoverPicture>
		</div>
	</div>
</template>

<script>
import HoverPicture from './HoverPicture';
export default {
	name: 'ExcellentEnterprise',
	components: {
		HoverPicture
	},
	props: {},
	data() {
		return {
			firstGroup: [
				{
					id: 0,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/2de174fdb5b2bf5069c3dd23ca000743.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/d964abb0461950139172c113816ad6e9.png'
				},
				{
					id: 1,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/defffa2ed7dfa433d3ce2ad888b8b6cf.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/854b6e7adc2d48619b839449bdc38218.png'
				},
				{
					id: 2,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/a0cf044150e36ce95a4b9e55da1377ef.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/f760fc315119dff9bffaeef3ee717904.png'
				},
				{
					id: 3,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/e7bbf107b1e71b36fef19f42612c5976.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/b123884558fe70cb19ab6b91b3340b51.png'
				},
				{
					id: 4,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/acc6f970797a3ac0e887be509dbcb559.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/c129e482352847ad8b23c9ad212aad90.png'
				},
				{
					id: 5,
					icon: 'https://static.bimcc.com/openim/%E4%B8%AD%E5%9B%BD%E5%BB%BA%E7%AD%91%EF%BC%88%E7%81%B0%E8%89%B2%EF%BC%89%201%20%281%29EA7E0EF561FCA6392488C7E770B60B46.png',
					hoverIcon:
						'https://static.bimcc.com/openim/%E4%B8%AD%E5%9B%BD%E5%BB%BA%E7%AD%91%EF%BC%88%E5%BD%A9%E8%89%B2%EF%BC%89FA6E8B5227AD8C282D0F3FB0908D8682.png'
				}
			],
			secondGroup: [
				{
					id: 0,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/569334cbba6b198110f2fef41a923f4b.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/71a261a41d87a75d761f8524efc1753c.png'
				},
				{
					id: 1,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/21cb4b80d5c836d39bba229d29aaa44f.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/8493698c5857551593c71d5ef265f294.png'
				},
				{
					id: 2,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/c237964345c7f0f0dddd84f8eaeac3c5.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/cbac70877afc172f56631091af6a90c7.png'
				},
				{
					id: 3,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/bcd6deddd9f2362b67bf3f42b5746256.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/af09eb9c6dfe984385233f85ecab0277.png'
				},
				{
					id: 4,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/8dc7d249388f791ec012fae9c65c99ab.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/f87fd4260b99c8c904edba93a8bdcfd3.png'
				},
				{
					id: 5,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/663192016fe8e0abade78e9ee145c31c.png',
					hoverIcon:
						'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/e8c501c3a319eba81b070ebb68a2bb39.png'
				}
			],
			thirdGroup: [
				{
					id: 0,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/5c68162bf0947e302022a9716ba090f6.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/ce9f581fa9f2b75a3edd2b6d8e0c04d7.png'
				},
				{
					id: 1,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/7bc41cd0994ed214a2198beb17f15c38.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/50075cf7e640b5581f174333db100032.png'
				},
				{
					id: 2,
					hoverIcon:
						'https://static.bimcc.com/openim/%E5%8E%A6%E9%97%A8%E5%A4%A7%E5%AD%A6%EF%BC%88%E5%BD%A9%E8%89%B2%EF%BC%89%20%281%2936E21DE0432A4F86E62829716C85E4EB.png',
					icon: 'https://static.bimcc.com/openim/%E5%8E%A6%E9%97%A8%E5%A4%A7%E5%AD%A6%281%294129ECA9D77796E29E8D281D4F52172A.png'
				},
				{
					id: 3,
					icon: 'https://static.bimcc.com/openim/%E9%87%8D%E5%BA%86%E4%BA%A4%E9%80%9A%E5%A4%A7%E5%AD%A6%EF%BC%88%E5%BD%A9%E8%89%B2%EF%BC%89%201%20%281%2992AFEBCDA71D724F5650AA40EDB807A6.png',
					hoverIcon:
						'https://static.bimcc.com/openim/%E9%87%8D%E5%BA%86%E4%BA%A4%E9%80%9A%E5%A4%A7%E5%AD%A6%EF%BC%88%E5%BD%A9%E8%89%B2%EF%BC%895AA6239999CCA3012A6CF288B9E25540.png'
				},
				{
					id: 4,
					icon: 'https://static.bimcc.com/openim/%E9%87%8D%E5%BA%86%E5%A4%A7%E5%AD%A6%28%E7%81%B0%E8%89%B2%29477CE2A36A8A6B7340B59585BCE8712C.png',
					hoverIcon:
						'https://static.bimcc.com/openim/%E9%87%8D%E5%BA%86%E5%A4%A7%E5%AD%A6%28%E5%BD%A9%E8%89%B2%29A2784166FA7CC28DE7D06B70E7A78CF7.png'
				},
				{
					id: 5,
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/75c705f5603081354bf292801e90bf01.png',
					hoverIcon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/da249d97e779f4fbf6775db1681f8244.png'
				}
			]
		};
	},
	methods: {}
};
</script>

<style lang="less" scoped>
.enterprises {
	position: relative;
	width: 1200px;
	height: 864px;
	h1 {
		padding: 103px 0;
		box-sizing: border-box;
		color: #000000;
		font-family: 'Source Han Sans CN';
		font-style: normal;
		font-weight: 700;
		font-size: 42px;
		line-height: 63px;
		text-align: center;
	}
	.first-group {
		width: 100%;
		height: 100%;
	}
	.second-group {
		position: absolute;
		top: 400px;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.third-group {
		position: absolute;
		top: 530px;
		left: 0;
		width: 100%;
		height: 100%;
	}
}
</style>
